import { createAsyncThunk } from '@reduxjs/toolkit'
import { getAxiosRequestConfig, newRequest } from 'utils/request.ts'
import { Methods, NewResponse } from 'types/request.ts'
import { GetUserLoginsPayload, GetUserLoginsResponse, GetUsersResponse } from 'store/user/thunks/types.ts'

export const getUserLogins = createAsyncThunk<GetUserLoginsResponse, GetUserLoginsPayload>(
  'portalUser/getPortalLogins',
  async ({ from, till }, thunkAPI) => {
    try {
      const { success, data, message }: NewResponse<GetUserLoginsResponse> = await newRequest(
        getAxiosRequestConfig(Methods.GET, `/users/logins?from=${from}&till=${till}`)
      )

      if (!success || !data) {
        return thunkAPI.rejectWithValue(message ?? 'getPortalLogins')
      }

      return { logins: data.logins }
    } catch (err) {
      const { message } = err as Error
      return thunkAPI.rejectWithValue(message)
    }
  }
)

export const getUsers = createAsyncThunk<GetUsersResponse>('user/getUsers', async (_, thunkAPI) => {
  try {
    const { success, data, message }: NewResponse<GetUsersResponse> = await newRequest(getAxiosRequestConfig(Methods.GET, '/users'))

    if (!success || !data) {
      return thunkAPI.rejectWithValue(message ?? 'getUsers')
    }

    return { users: data.users }
  } catch (err) {
    const { message } = err as Error
    return thunkAPI.rejectWithValue(message)
  }
})
